import React from 'react';
import { useDispatch } from 'react-redux';
import { addLabelClass } from '../../redux/actions/labelClasses';
import './AddLabelClass.css';

var AddLabelClass = function AddLabelClass() {
  var dispatch = useDispatch();

  var handleClick = function handleClick() {
    dispatch(addLabelClass());
  };

  return /*#__PURE__*/React.createElement("div", {
    onClick: handleClick,
    className: "add-class-btn panel--round"
  }, /*#__PURE__*/React.createElement("b", null, "+ Add Label Class"));
};

export default AddLabelClass;